import { render } from "./OrderSelection.vue?vue&type=template&id=56da1328&scoped=true"
import script from "./OrderSelection.vue?vue&type=script&lang=js"
export * from "./OrderSelection.vue?vue&type=script&lang=js"

import "./OrderSelection.vue?vue&type=style&index=0&id=56da1328&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56da1328"]])

export default __exports__